module.exports = __webpack_public_path__ + "static/media/7.47c3aaf1.JPG";